/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { createRef } from "react";
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import 'swiper/components/pagination/pagination.less'
import PropTypes from "prop-types";
import { Exposure } from 'shihuo-lib/dist/shihuo-lib';
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import "./style.less";

class PipelineImgList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.swiperRef = createRef();
    this.swiperPaginationRef = createRef();
    this.exp = new Exposure(); // 曝光
    this.screenRatio = 1;
    if (typeof window !== 'undefined') {
      this.screenRatio = window.document.body.clientWidth / 375;
    }
  }

  componentDidMount() {
    // 轮播组件初始化
    const autoplay = this.props.config.baseConfig.autoPlay === '是' ?
    {
      delay: 3000,
      disableOnInteraction: false,
    } : false;
    const swiper = new Swiper(this.swiperRef.current, {
      pagination: {
        el: this.swiperPaginationRef.current,
      },
      // lazy: true,
      autoplay,
      loop: true,
      enabled: this.props.config.imgsList.length > 1
    });

    // 2100ms之后加载剩余图片
    // setTimeout(() => {
    //   const imgLength = this.props.config.imgsList.length;
    //   for (let index = 1; index < imgLength; index += 1) {
    //     swiper.lazy.loadInSlide(index);
    //   }
    // }, 2100);
  }

  handleItemClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }
    if (!item.link) {
      // 空白不跳转
      return;
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      link: item.link,
      type: baseConfig.sortType,
      sort: index,
    };

    const convertUrl = utils.convertHref(item.link);
    utils.jumpToUrl(this.props.routeParams,convertUrl,item.link, options, -1,this.props,false);

  }

  render() {
    const { baseConfig, imgsList } = this.props.config;

    return (
      <div
        className="pipeline-search-swiper"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          marginTop: px2rem('8px', false),
          marginBottom: px2rem('12px', false),
          marginLeft: px2rem(`12px`, false),
          marginRight: px2rem(`12px`, false),
        }}
      >
        <div className="swiper-container" ref={this.swiperRef} style={{ height: px2rem('152px', false) }}>
          <div className="swiper-wrapper">
            {imgsList.map((item, index) => {
              return (
                <div className="swiper-slide" key={index} onClick={this.handleItemClick.bind(this, item, index)}>
                  <img
                    className="slide-img"
                    src={utils.formatImgUrl(item.src, this.props.webpSupport)}
                    data-dot={JSON.stringify({
                      id: 'legoSearchCard:activity_banner',
                      name: 'pipeline-searchSwiper',
                      href: '',//跳转的 href, 非必传
                      exposekey: 'activity_banner',//必传
                      from_sort: index,
                      pti_refer: {
                        // pageId: this.pageId,
                        root: {
                          // pageId: this.pageId,
                          biz: ''
                        },
                        parent: {},
                      },
                    })}              
                    ref={ele => {
                      if (ele) {
                        this.exp.add({ el: ele });
                      }
                    }}  
                    alt=""
                  />
                  {/* <div class="swiper-lazy-preloader"></div> */}
                </div>
              );
            })}
          </div>
          <div className="swiper-pagination" ref={this.swiperPaginationRef}></div>
        </div>
      </div>
    );
  }
}

PipelineImgList.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineImgList };
export default PipelineImgList;



// WEBPACK FOOTER //
// ./components/pipeline-searchSwiper/index.js